import { render, staticRenderFns } from "./simpleTimerControl.vue?vue&type=template&id=0dc95a5d&scoped=true"
import script from "./simpleTimerControl.vue?vue&type=script&lang=js"
export * from "./simpleTimerControl.vue?vue&type=script&lang=js"
import style0 from "./simpleTimerControl.vue?vue&type=style&index=0&id=0dc95a5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc95a5d",
  null
  
)

export default component.exports